// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap__2ocKT","img":"index_img__3ofO4","content":"index_content__3wQdu","slide":"index_slide__3ZxO5","txt":"index_txt__Oissw"};